import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum VoiceBotStatus {
  ACTIVE = "active",
  LISTENING = 'listening',
  THINKING = 'thinking',
  SPEAKING = 'speaking',
  SLEEPING = 'sleeping',
  NOTSTARTED = "not-started",
  NONE = '',
}

@Injectable({
  providedIn: 'root',
})
export class VoiceBotService {
  private status = new BehaviorSubject<VoiceBotStatus>(VoiceBotStatus.NONE);
  private messages = new BehaviorSubject<string[]>([]);

  getStatus() {
    return this.status.asObservable();
  }

  setStatus(newStatus: VoiceBotStatus) {
    this.status.next(newStatus);
  }

  addMessage(message: string) {
    this.messages.next([...this.messages.getValue(), message]);
  }

  startListening() {
    this.status.next(VoiceBotStatus.LISTENING);
  }

  startSpeaking() {
    this.status.next(VoiceBotStatus.SPEAKING);
  }

  toggleSleep() {
    this.status.next(
      this.status.getValue() === VoiceBotStatus.SLEEPING ? VoiceBotStatus.LISTENING : VoiceBotStatus.SLEEPING
    );
  }
}
